// extracted by mini-css-extract-plugin
module.exports = {"vanlife-L-smart-series":"Series_vanlife-L-smart-series__P4cHD"};